'use client';

import { c as _c } from "react/compiler-runtime";
import { useReducer } from 'react';
import { INITIAL_ANSWERS, QUESTIONS } from '../_lib/constants';
import type { AnswerKey, ChatbotAction, ChatbotState, ChatMessage } from '../_lib/types';
const initialState: ChatbotState = {
  messages: [],
  answers: INITIAL_ANSWERS,
  step: 0
};
const chatbotReducer = (state: ChatbotState, action: ChatbotAction): ChatbotState => {
  switch (action.type) {
    case 'ADD_MESSAGE':
      {
        const lastMessage = state.messages[state.messages.length - 1];

        // 연속된 bot 메시지는 하나로 합침
        if (lastMessage?.type === 'bot' && action.message.type === 'bot' && !lastMessage.options) {
          const mergedMessage = {
            ...lastMessage,
            content: `${lastMessage.content}\n\n${action.message.content}`,
            options: action.message.options,
            timestamp: action.message.timestamp
          };
          return {
            ...state,
            messages: [...state.messages.slice(0, -1), mergedMessage]
          };
        }
        return {
          ...state,
          messages: [...state.messages, action.message]
        };
      }
    case 'SET_ANSWER':
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.key]: action.value
        }
      };
    case 'NEXT_STEP':
      return {
        ...state,
        step: state.step + 1
      };
    case 'SHOW_RESULT':
      return {
        ...state,
        step: QUESTIONS.length + 1
      };
    case 'RESTART':
      return initialState;
    default:
      return state;
  }
};
export const useChatbotReducer = () => {
  const $ = _c(12);
  const [state, dispatch] = useReducer(chatbotReducer, initialState);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (type, content, options) => {
      dispatch({
        type: "ADD_MESSAGE",
        message: {
          id: `${type}-${Date.now()}`,
          type,
          content,
          timestamp: new Date(),
          options
        }
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const addMessage = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (key, value) => {
      dispatch({
        type: "SET_ANSWER",
        key,
        value
      });
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setAnswer = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      dispatch({
        type: "NEXT_STEP"
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const nextStep = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      dispatch({
        type: "SHOW_RESULT"
      });
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const showResult = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      dispatch({
        type: "RESTART"
      });
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const restart = t4;
  const showResultStep = state.step > QUESTIONS.length;
  const currentQuestion = state.step > 0 ? QUESTIONS[state.step - 1] : null;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      addMessage,
      setAnswer,
      nextStep,
      showResult,
      restart
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== currentQuestion || $[7] !== showResultStep) {
    t6 = {
      showResultStep,
      currentQuestion
    };
    $[6] = currentQuestion;
    $[7] = showResultStep;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== state || $[10] !== t6) {
    t7 = {
      state,
      actions: t5,
      derived: t6
    };
    $[9] = state;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};